var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOngoingComparisonOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4062 27.0938C13.5 30.5312 13.125 32.1562 13.125 32.4688C13.125 32.7188 15.1875 32.8125 20 32.8125C24.8125 32.8125 26.875 32.7188 26.875 32.4688C26.875 32.1562 26.5 30.5312 25.5938 27.0938L25.2812 25.9375H20H14.7188L14.4062 27.0938ZM21.25 29.375V30.625H20H18.75V29.375V28.125H20H21.25V29.375Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1875 35.6875C12.1875 35.9062 12.0938 36.4062 12 36.7812L11.8125 37.5H20H28.1875L28 36.8125C27.9062 36.4062 27.8125 35.9062 27.8125 35.6875C27.8125 35.4062 26.0312 35.3125 20 35.3125C13.9688 35.3125 12.1875 35.4062 12.1875 35.6875Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 23.6077,
    width: 30,
    height: 2.5,
    transform: "rotate(-14.1967 5 23.6077)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4134 4.86418C24.0934 5.46967 23.0156 6.0025 23.0156 6.05094C23.0156 6.15993 27.7627 8.35181 27.9928 8.35181C28.1865 8.35181 33.0547 6.14782 33.0547 6.05094C33.0547 5.95406 28.1865 3.75008 27.9806 3.75008C27.8838 3.75008 26.7212 4.24658 25.4134 4.86418Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.167 9.65948V12.5295L24.8312 13.7526L27.4953 14.9878V12.1057V9.22352L26.9261 8.98133C26.5992 8.84812 25.4003 8.29107 24.262 7.75824L22.167 6.78945V9.65948Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1048 8.03686L28.4648 9.25995V12.13V15L30.5598 14.0312C31.6982 13.4984 32.897 12.9413 33.224 12.8081L33.7932 12.5659V9.67168C33.7932 8.07319 33.7811 6.77744 33.7689 6.78955C33.7447 6.80166 32.5458 7.35871 31.1048 8.03686Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24638 9.86418C6.92641 10.4697 5.84863 11.0025 5.84863 11.0509C5.84863 11.1599 10.5957 13.3518 10.8258 13.3518C11.0195 13.3518 15.8877 11.1478 15.8877 11.0509C15.8877 10.9541 11.0195 8.75008 10.8137 8.75008C10.7168 8.75008 9.55423 9.24658 8.24638 9.86418Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.6595V17.5295L7.66416 18.7526L10.3283 19.9878V17.1057V14.2235L9.75916 13.9813C9.43219 13.8481 8.23332 13.2911 7.095 12.7582L5 11.7895V14.6595Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9378 13.0369L11.2979 14.2599V17.13V20L13.3928 19.0312C14.5312 18.4984 15.73 17.9413 16.057 17.8081L16.6262 17.5659V14.6717C16.6262 13.0732 16.6141 11.7774 16.6019 11.7895C16.5777 11.8017 15.3789 12.3587 13.9378 13.0369Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOngoingComparisonOperationIcon);
export default __webpack_public_path__ + "static/media/OngoingComparisonOperationIcon.00dc42d1f9b5c886d5212626592a5715.svg";
export { ForwardRef as ReactComponent };